import { ChipsideComponent } from "../chipside-component";

export class Prompt extends ChipsideComponent {
	static observedAttributes = ["size", "icon"];

	constructor() {
		super();

		this.icon = this.getAttribute("icon") ?? "";
		this.heading = this.getAttribute("heading") ?? "";
		this.size = this.getAttribute("size") ?? "";
	}

	parsedCallback() {
		this.appendChild(document.createElementWithContents("div", this.childNodes, { className: "prompt__description" }));

		if (this.heading) { this.prepend(document.createElementWithContents("div", this.heading, { className: "prompt__title" })); }
		if (this.icon) { this.prepend(document.createElementWithContents("div", document.createElementWithContents("i", null, { className: this.icon }), { className: "prompt__icon" })); }
	}

	attributeChanged(name, _, newValue) {
		if (name === "icon") {
			let element = this.querySelector(".prompt__icon");

			if (!element) {
				element = document.createElementWithContents("div", document.createElementWithContents("div", document.createElementWithContents("i", null, { className: this.icon }), { className: "prompt__icon" }));
			}

			element.querySelector("i").className = newValue;
		}
	}
}